var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.presentation.id && _vm.renderPresentationDetail && !_vm.isPresentingPpt)?_c('div',{staticClass:"z-10 h-14 md:h-15 aha-presentation-editor-header",class:{'in-demo-mode': _vm.isGuestUser, 'ppt-header': _vm.isEnableAddinPowerpoint}},[_c('EditorHeader',{on:{"update-online-count":_vm.updatePresentationSessionOnlineCount}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }